import axios from "../../../axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * Get Departments
 */
export const getDepartments = async () => {
  try {
    const { data } = await axios.get("tickets/departments");

    //
    let list = data.result;

    //
    return list;
  } catch (error) {
    return false;
  }
};

/**
 * Get Tickets
 */
export const getTickets = async () => {
  try {
    const { data } = await axios.get("tickets");

    //
    let tickets = data.result;

    //
    return tickets;
  } catch (error) {
    return false;
  }
};

/**
 * Send New Ticket
 */
export const sendNewTicket = async (payload) => {
  try {
    await axios.post("tickets/new", payload);

    //
    toast.success("New Ticket Send", {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });

    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Get Ticket
 * @param {ticket id} payload
 */
export const getTicket = async (payload) => {
  try {
    const { data } = await axios.get(`tickets/${payload}/answers`);

    //
    let ticket = data.result;

    //
    return ticket;
  } catch (error) {
    return false;
  }
};

/**
 * Send Answer To Ticket
 * @param {id , content} payload 
 */
export const sendAnswer = async (payload) => {
  try {
    const {data} = await axios.post(`tickets/${payload.id}/answers/new` , payload.fd);

    //
    let tickets = data.result;

    //
    return tickets
  } catch (error) {
    return false
  }
}
